export default __webpack_public_path__ + "static/media/mainlogo.697493d9.png";